import { render } from "./Feedback.vue?vue&type=template&id=e8eb5adc&ts=true&lang=pug"
import script from "./Feedback.vue?vue&type=script&setup=true&lang=ts"
export * from "./Feedback.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__